import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Ir8aAmountReducer } from '../reducers';

export const selectFeature = createFeatureSelector<Ir8aAmountReducer.Ir8aAmountState>(Ir8aAmountReducer.featureName);

export const selectItem = createSelector(selectFeature, (state: Ir8aAmountReducer.Ir8aAmountState) => state.item);
export const selectSalesperson = createSelector(selectFeature, ({ salesperson }) => salesperson);
